// Small auth utilities used across pages to ensure we read token from both storages
// Also gracefully fallback to URL query token (?t= or ?token=) for early consumers
// like WebRTC/socket before AuthContext finishes initializing.
export function getAuthToken() {
  try {
    // 1) Prefer persisted tokens
    const stored = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (stored) return stored;

    // 2) Fallback: check URL query for token parameters
    try {
      const url = new URL(window.location.href);
      const urlToken = url.searchParams.get('t') || url.searchParams.get('token');
      if (urlToken) {
        // Cache into sessionStorage for this tab so subsequent calls see it
        try { sessionStorage.setItem('token', urlToken); } catch (_) {}
        return urlToken;
      }
    } catch (_) {
      // ignore URL parsing errors
    }

    return null;
  } catch (_) {
    return null;
  }
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem('user') || sessionStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}
